import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { VendorDetailActions } from "stores/VendorDetailsStore/VendorDetailAction";

const mapStateToProps = (state) => {
  return {
    RequestViewVendorList: state.Vendordetail.RequestViewVendorList,
    ShowViewList: state.Vendordetail.ShowViewList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRequestViewDetailsVendorAction:
        VendorDetailActions.getRequestViewDetailsVendorAction,
      getShowViewDetail: VendorDetailActions.getShowViewDetail,
    },
    dispatch
  );

const RequestViewDetailsVendorStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default RequestViewDetailsVendorStore;
